"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1476],{

/***/ 51476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M15.5 3c-3 0-5.5 2.5-5.5 5.5 0 .6.1 1.2.3 1.8l-8 8c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l.8-.8 1.8 1.8c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1.8-1.8L7 16.4l2.3 2.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L8.4 15l2.9-2.9c1 1.2 2.5 1.9 4.2 1.9 3 0 5.5-2.5 5.5-5.5S18.5 3 15.5 3zm0 9c-1.9 0-3.5-1.6-3.5-3.5S13.6 5 15.5 5 19 6.6 19 8.5 17.4 12 15.5 12z"
}), "KeyCollection"));


/***/ })

}]);